import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';

export interface AlertHtmlDialogData {
  title: string;
  actionTitle: string;
  html: string;
  code: boolean;
}

@Component({
    selector: 'app-mat-alert-html-dialog',
    template: `
      <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
          <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
              <div fxFlex>{{data.title}}</div>
              <button mat-icon-button [mat-dialog-close]="false" class="button-40">
                  <mat-icon>close</mat-icon>
              </button>
          </h1>
          <mat-dialog-content class="mat-typography" fxFlex>
              <div [innerHTML]="data.html" *ngIf="!data.code"></div>
              <pre *ngIf="data.code">
                {{data.html}}
              </pre>
          </mat-dialog-content>
          <mat-dialog-actions align="end">
              <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{data.actionTitle || 'Close'}}</button>
          </mat-dialog-actions>
      </div>
  `,
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        NgIf,
        MatDialogActions,
        MatButton,
    ],
})
export class MatAlertHtmlDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: AlertHtmlDialogData) {}

  ngOnInit() {
    console.log(this.data);
  }
}
